import { Dispatch } from '@reduxjs/toolkit';

import { fetchUserLocation as apiFetchUserLocation } from 'api/apiUserLocation';
import { ApiUserLocation } from 'api/types/ApiUserLocation';

import {
  FetchUserLocationRequestAction,
  FetchUserLocationSuccessAction,
  MainStoreUserLocationAction,
  MainStoreUserLocationState,
} from './userLocation';

function fetchUserLocationRequest(): FetchUserLocationRequestAction {
  return {
    type: 'USER_LOCATION_FETCH_REQUEST',
  };
}

function fetchUserLocationSuccess(
  userLocation: ApiUserLocation,
): FetchUserLocationSuccessAction {
  return {
    type: 'USER_LOCATION_FETCH_SUCCESS',
    userLocation,
  };
}

export function fetchUserLocation() {
  return (
    dispatch: Dispatch<MainStoreUserLocationAction>,
    getState: () => { userLocation: MainStoreUserLocationState },
  ) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const userLocation = getState().userLocation;

    if (userLocation.isFetching || userLocation.isLoaded) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchUserLocationRequest());
    return apiFetchUserLocation().then((fetchedUserLocation) =>
      dispatch(fetchUserLocationSuccess(fetchedUserLocation)),
    );
  };
}
